<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/layout/Header';
  import Footer from '@/components/layout/Footer';

  export default {
    name: 'App',
    components: {
      Footer,
      Header,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data Model
    //
    //---------------------------------------------------
    data() {
      return {
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    async mounted() {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
    },
  };
</script>

<style lang="scss">
@import '~scss/app';
@import '~scss/mixins';
@import '~scss/variables';

main {
  min-height: calc(100vh - 120px);
  margin-top: 120px !important;
  padding: 40px 0;

  @include screen-tablet {
    min-height: calc(100vh - 60px);
    margin-top: 60px !important;
  }
}
</style>
